// extracted by mini-css-extract-plugin
export default {"articleList":"M4erQep_SVsQTadsIczb","loading":"MNaGgFgR6Yf15zM1aFDT","emptyState":"awKkhwh8OeVYFzNpX5LC"};